import { msg } from '@lingui/core/macro';
import type { OnboardingStep } from 'modules/main/domain/interfaces/onboarding-step';
import { Pages } from 'modules/navigation/domain/enums/pages';

export const steps: OnboardingStep[] = [
  {
    emoji: '🏃🏃‍♀️🏃🏻‍♂️',
    header: msg`Создай команду`,
    action: msg`Создать`,
    to: Pages.TEAMS.CREATE,
    checkProperty: 'stepper:main:createTeam',
  },
  {
    emoji: '🏋️‍♂️️️',
    header: msg`Добавь игроков`,
    action: msg`Добавить`,
    to: Pages.PLAYERS.CREATE,
    checkProperty: 'stepper:main:createPlayer',
  },
  {
    emoji: '🏆',
    header: msg`Создай турнир`,
    action: msg`Создать`,
    to: Pages.CHAMPIONSHIPS.CREATE,
    checkProperty: 'stepper:main:createTournament',
  },
  {
    emoji: '🗒️️️',
    header: msg`Заяви команду`,
    action: msg`Заявить`,
    to: Pages.TEAMS.INDEX,
    checkProperty: 'stepper:main:applicationTeam',
  },
  {
    emoji: '📆️',
    header: msg`Запусти турнир`,
    action: msg`Запустить`,
    to: Pages.CHAMPIONSHIPS.INDEX,
    checkProperty: 'stepper:main:startTournament',
  },
  {
    emoji: '📱️',
    header: msg`Управляй`,
    action: msg`Начать`,
    to: Pages.SCHEDULE.INDEX,
    checkProperty: 'stepper:main:manageTournament',
  },
];
